import { render } from "./newTransactionModal.vue?vue&type=template&id=631d23fe"
import script from "./newTransactionModal.vue?vue&type=script&lang=js"
export * from "./newTransactionModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/tio-patinhas/tio-patinhas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__